import {AbstractEvent} from "@/modules/base/events";
import {TransferOffer} from "@/modules/transfer-market/entity";
import {Player} from "@/modules/team/entity";

export class BeforeTransferOfferAbortedEvent extends AbstractEvent {
  constructor(
    public offer: TransferOffer,
    public player: Player,
  ) {
    super();
  }
}